import { Injectable } from '@angular/core';
import { DataBridgeService } from './services/data-bridge.service';

@Injectable({
  providedIn: 'root'
})
export class IndoorMappingComponentService {

  constructor(private _dataBridgeService: DataBridgeService) { }
  getProcessedDataFromLayout(layout){
    return this._dataBridgeService.convertDataToGeoJson(layout);
  }
}
